import { render, staticRenderFns } from "./SecureSignFormRecaptcha.vue?vue&type=template&id=f460e9ec"
import script from "./SecureSignFormRecaptcha.vue?vue&type=script&lang=js"
export * from "./SecureSignFormRecaptcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports